import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';
import styles from './styles.css';

export const MarkdownListOverrider = ({
    children,
    dataTestId,
    hasMarginTop = false,
    type: ListType = 'ul',
}: IProps) => {
    return (
        <ListType
            className={cn(styles.list, { [styles.listWithMargin]: hasMarginTop })}
            data-test-id={dataTestId}
        >
            {children}
        </ListType>
    );
};
